import axios from '../Util/AxiosIntercepted';

function getChatMessagesByRoomId(roomId) {
    const query = `
    {
        getChatMessagesByRoomId(roomId: "${roomId}") {
            chatMessageId
            chatMessageDate
            sender {
                userId
                email
                firstName
                lastName
            }
            text
            slideTags {
                slideItemId
                slideNumber
                deleted
            }
            question
            replies {
                chatMessageId
                chatMessageDate
                sender {
                    userId
                    firstName
                    lastName
                }
                text
            }
        }
    }`;

    const request = {
        query,
        variables: {}
    };

    // return axios.post(`${process.env.REACT_APP_API_HOST}/vyu/graphql`, request).then(
    return axios.post(`/vyu/graphql`, request).then(({ data }) => {
        // A rejected query comes back 200 with `data: null` and the reason in
        // `errors`, so axios never rejects. Destructuring straight to the
        // payload threw a TypeError that the caller's catch swallowed, leaving
        // the panel on its empty state with nothing to distinguish "no
        // messages" from "this request is failing".
        //
        // The realistic trigger is version skew: GraphQL rejects the whole
        // operation on one unknown field, so a bundle asking for a field the
        // deployed backend doesn't have yet loses every message, not just the
        // new one. See #180.
        if (data.errors && data.errors.length) {
            throw new Error(data.errors[0].message || 'Failed to load messages');
        }
        if (!data.data || data.data.getChatMessagesByRoomId == null) {
            throw new Error('Failed to load messages');
        }
        return data.data.getChatMessagesByRoomId;
    });
}

// `parentChatMessageId` makes this a reply: it inherits the parent's scope, so
// the server refuses one that also carries slideIds or question.
async function createChatMessage(
    roomId,
    text,
    chatMessageDate,
    slideIds = [],
    question = false,
    parentChatMessageId = null
) {
    const query = `
    mutation($chatMessage:NewChatMessage!) { 
        createChatMessage(roomId:"${roomId}", chatMessage:$chatMessage) { 
            chatMessageId
            chatMessageDate
            room {
                roomId
            }
            text
            slideTags {
                slideItemId
                slideNumber
                deleted
            }
            question
        } 
    }`;
    const chatMessage = { text, chatMessageDate, slideIds, question };
    // Omitted rather than sent as null when there is no parent. GraphQL rejects
    // the whole mutation on an unknown input field, so while a deploy still has
    // a new frontend talking to an old backend (#180), sending it always would
    // fail every ordinary chat and not just the replies. Absent and null are
    // the same message to the current backend, which only asks whether the
    // field is null.
    if (parentChatMessageId != null) {
        chatMessage.parentChatMessageId = parentChatMessageId;
    }
    const variables = { chatMessage };
    const request = {
        query,
        variables
    };
    // Bound both chat and reply sends so a stalled request releases the composer.
    return axios.post(`/vyu/graphql`, request, { timeout: 30000 }).then(({ data }) => {
        // A rejected mutation still comes back 200 with an `errors` array, so
        // axios never rejects and the payload's createChatMessage is just null.
        // Without this the caller cannot tell a refused send (e.g. a tag on a
        // slide that was deleted mid-draft) from a successful one.
        if (data.errors && data.errors.length) {
            throw new Error(data.errors[0].message || 'Failed to send message');
        }
        return data.data.createChatMessage;
    });
}
export default {
    createChatMessage,
    getChatMessagesByRoomId
};
